import { useUpdateHealthMonitor } from './useUpdateHealthMonitor'

/**
 * Renders nothing — mounts the observation-only live-update health monitor.
 * Place inside the authenticated provider tree (next to ResourceStreamSynchronizer)
 * so it has access to the query client and the server-log client.
 */
export const UpdateHealthMonitor = () => {
  useUpdateHealthMonitor()
  return null
}
